import { Component, OnInit, OnDestroy, Pipe, PipeTransform, HostListener } from '@angular/core';
//import { ModulService } from '../modul.service';
import { MjestaService } from '../mjesta.service';
import { ClanoviService } from '../clanovi.service';
import { formatDate } from '@angular/common';
import { ModulService, PosJedinice } from '../modul.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Clanstvo } from '../clanstva/clanstva.component';
import { Validators } from '@angular/forms';
import { ClanarineService, Vclanarina } from '../clanarine.service';
import { ClanEditService } from '../clan-edit.service';
import { Grupa, GrupeService } from '../grupe.service';

export interface ClPostavka {
  vID: number,
  opis_vrsta_cl: string,
  posJed: PosJed[]
}

export interface PosJed {
  PoslJedID: number,
  NazivPos: string
}

@Component({
  selector: 'app-clan-edit',
  templateUrl: './clan-edit.component.html',
  styleUrls: ['./clan-edit.component.scss'],
})

export class ClanEditComponent implements OnInit, OnDestroy {

  constructor(
    public mod: ModulService,
    public srvMjesta: MjestaService,
    public srvClan: ClanoviService,
    public srvClanarine: ClanarineService,
    public srvClanEdit: ClanEditService,
    public srvGrupe: GrupeService
  ) { }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    localStorage.setItem('clanID', this.srvClan.clanID.toString());
  }

  objPosJed: PosJedinice[];


  objClPostavke: ClPostavka[];
  objClPosJedSel: PosJed[];

  danas = moment();

  ngOnInit() {

    let tok: string;
    if (localStorage.getItem('token')) {
      tok = localStorage.getItem('token');
    } else {
      tok = this.mod.objKor.token;
    }

    if (!this.srvClan.clanID && localStorage.getItem('clanID')) {
      this.srvClan.clanID = Number(localStorage.getItem('clanID'));
      localStorage.removeItem('clanID');
    }
    

    this.mod.provjeraTokena(tok, () => {

      if (!this.srvMjesta.objMjestaRH) {
        this.srvMjesta.ucitajMjestaRH(() => {
        });
      }

      this.mod.ucitajPosJed(() => {

        if (this.mod.objPosJed) {
          this.objPosJed = this.mod.objPosJed;
          this.pocetnePostavke();
        } else {

          this.mod.session = null;
          this.mod.provjeraPrijaveTrenOper((rez) => {

            this.srvClan.posjedByTrenOper(this.mod.session.KlijentIDtren, this.mod.session.KoriniskIDtren, this.mod.session.clanVrstaIDtren, (rez: PosJedinice[]) => {
              this.objPosJed = rez;
            });

            this.pocetnePostavke();

          });

        }

        localStorage.clear();

      });

    });

  }

  //Pocetne postavke
  pocetnePostavke() {

    //Frm Članovi
    this.srvClan.postaviFrmClanovi(this.srvClan.clanID, () => {
      this.mjestaListener();
    });

    //frm članstvo
    this.srvClan.napraviFrmClanstvo(() => {

    });

    //Članstva
    this.srvClan.ucitajClanstvaList();
    this.srvClan.ucitajClanstva(this.srvClan.clanID);

    //važeće članarine
    this.srvClanarine.vazeceByClanArr(this.srvClan.clanID, moment(), (rez: Vclanarina[]) => {
      this.srvClanEdit.objVazeceClanarine = rez;
    });

    //Upisan u grupe:
    this.srvGrupe.grupeByClanId(this.srvClan.clanID, (rez: Grupa[]) => {
      this.srvClanEdit.objGrupe = rez;
    });

  }

  //Listener Mjesto ComboBox
  mjestaListener() {

    this.srvMjesta.fltMjesta = [];
    
    this.srvClan.frmClan.get('Mjesto').valueChanges.subscribe(value => {

      if (value && value.length >= 3) {
        this.srvMjesta.filtrirajMjestaRH(value);
      } else {
        this.srvMjesta.fltMjesta = [];
      }

    });

  }

  //SET MjestoID (mod.objKor.MjestoID)
  postaviMjestoID(mjestoID: number) {
    this.srvClan.frmClan.patchValue({ MjestoID: mjestoID });
  }

  //Članstvo cmb 
  postaviClanstvoIDfrm(clID: string) {
    this.srvClan.frmClanstvo.controls['vrstaIDcl'].setValue(clID);
    //alert(JSON.stringify(this.srvClan.frmClanstvo.value));
  }

  //Postavi poslovnu jedinicu
  postaviPosJed(pjedID) {
    this.srvClan.frmClanstvo.controls['pjedIDcl'].setValue(pjedID);
  }

  //Spremi
  btnSpremi(clID: number) {
    this.srvClan.spremiClan(clID);
    //this.srvClan.ucitajClanstva(this.srvClan.clanID);
  }

  //Spremi članstvo
  spremiClanstvo() {

    this.srvClan.frmClanstvo.markAllAsTouched();

    if (this.srvClan.frmClanstvo.valid) {

      let vClansID: number = this.srvClan.frmClanstvo.get('vClansID').value;

      this.srvClan.spremiClanstvo(this.srvClan.frmClanstvo.value, (rez: Clanstvo) => {
        if (rez) {

          if (vClansID) {
            this.srvClan.objClanstva.forEach((val, ind) => {
              if (val.vClansID == rez.vClansID) {
                this.srvClan.objClanstva.splice(ind, 1, rez);
              }
            });
          } else {
            this.srvClan.objClanstva.push(rez);
          }

          document.getElementById('btnMdlClanstEditClose').click();

          this.mod.msgBox(1, "Spremljeno!", 2000);

        } else {
          this.mod.msgBox(2, "Greška prilikom spremanja", 3000);
        }
      });

    } else {
      this.mod.msgBox(2, "Popunite ispravno sva polja!", 3000);
    }

  }

  //Ikona - članstva
  iconClanstva(clID: string) {

    switch (clID) {

      case '1':
        return 'people';

      case '2':
        return 'emoji_people';

      case '3':
        return 'transfer_within_a_station';

    }

  }

  //Novo članstvo
  novoClanstvo() {

    this.objClPosJedSel = null;

    let clID: number = this.srvClan.clanID;
    let klID: number = this.mod.objPosJedSelected.KlijentIDpos;
    let cvID: number;

    if (this.mod.session) {
      cvID = this.mod.session.clanVrstaIDtren;
    } else {
      cvID = 0;
    }

    this.srvClan.clDostupnePj(clID, klID, cvID, (rez) => {

      this.srvClan.napraviFrmClanstvo(() => {
        this.srvClan.frmClanstvo.get('vrstaIDcl').addValidators(Validators.required);
      });

      if (rez && rez.length) {
        this.objClPostavke = rez;
      } else {
        this.objClPostavke = null;
      }

    });

    document.getElementById('btnMdlClanstEdit').click();
  }

  //Novo članstvo - odabir članstva i postavljanje dostupnih poslovnih jedinica
  ncPosJedOdabir(x) {
    this.objClPosJedSel = x;
  }

  //Uređivanje članstva
  clanstEditStart(x: Clanstvo) {

    this.srvClan.napraviFrmClanstvo(() => {
      this.srvClan.frmClanstvo.get('vrstaIDcl').removeValidators(Validators.required);
      this.srvClan.frmClanstvo.patchValue(x);
    });

    document.getElementById('btnMdlClanstEdit').click();

  }

  //poslovne jedinice - učitavanje ovisno o vrsti korisnika (vlasnik / trener, operater)


  //Chk aktivno / neaktivno
  clAktChk() {

    let chk: number = this.srvClan.frmClanstvo.get('intAkt').value;

    if (chk == 0) {
      this.srvClan.frmClanstvo.get('intAkt').setValue(1);
    } else {
      this.srvClan.frmClanstvo.get('intAkt').setValue(0);
    }

  }

  ngOnDestroy() {
    localStorage.setItem('clanID', this.srvClan.clanID.toString());
  }

}
